/*
 * Monsuri PDP — "Are you buying a gift?" note persistence.
 *
 * Writes the gift note to the native `cart.note` via /cart/update.js, so it persists
 * to the cart drawer, /cart, checkout, the order, and the packing slip. Debounced on
 * input, flushed on blur, and flushed again before any add/checkout click so it can't
 * be raced. After a successful write it syncs every OTHER cart-note control (the
 * cart-drawer gift-message <textarea name="note">) so a stale one can't overwrite this
 * note at checkout. Idempotent. Vanilla, dependency-free.
 *
 * cart.note is cart-level (one note per cart) — the established Monsuri gift contract.
 */
(function () {
  'use strict';

  function cartRoot() {
    var r = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return r.charAt(r.length - 1) === '/' ? r : r + '/';
  }

  function syncOtherNoteFields(note, sourceEl) {
    var fields = document.querySelectorAll('textarea[name="note"]');
    for (var i = 0; i < fields.length; i++) {
      if (fields[i] !== sourceEl) fields[i].value = note;
    }
  }

  function initGift(root) {
    if (root.hasAttribute('data-pdp-gift-ready')) return; // idempotent
    root.setAttribute('data-pdp-gift-ready', '');

    var ta = root.querySelector('[data-pdp-gift-note]');
    if (!ta) return;

    var timer = null;
    var lastSent = ta.value; // pre-filled with cart.note → no redundant write on load

    var pending = Promise.resolve();
    function writeNote() {
      var note = ta.value;
      if (note === lastSent) return pending;
      // Serialize writes: chain off the prior one so an older in-flight request can't
      // land AFTER a newer note and restore a stale cart.note (the race on rapid input).
      pending = pending.catch(function () {}).then(function () {
        var latest = ta.value;
        if (latest === lastSent) return;
        return fetch(cartRoot() + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ note: latest })
        }).then(function (res) {
          if (!res.ok) throw new Error('cart update failed');
          lastSent = latest;                 // dedup only AFTER a confirmed write
          syncOtherNoteFields(latest, ta);   // keep the drawer note in sync (anti-clobber)
        }).catch(function () { lastSent = null; }); // allow a retry on the next change/blur
      });
      return pending;
    }

    ta.addEventListener('input', function () {
      if (timer) clearTimeout(timer);
      timer = window.setTimeout(writeNote, 600);
    });
    ta.addEventListener('blur', function () {
      if (timer) { clearTimeout(timer); timer = null; }
      writeNote();
    });

    // Flush the pending note BEFORE an add / express checkout so it can't be raced.
    var scope = root.closest('.product__details') || root.closest('.product-main') || document;
    var buyButtons = scope.querySelectorAll('.add_to_cart, .shopify-payment-button, [data-pdp-sticky-add]');
    function flushNow() {
      if (timer) { clearTimeout(timer); timer = null; }
      writeNote();
    }
    for (var b = 0; b < buyButtons.length; b++) {
      buyButtons[b].addEventListener('pointerdown', flushNow, true); // earliest flush for mouse/touch
      buyButtons[b].addEventListener('click', flushNow, true);       // also covers keyboard + the sticky's programmatic .click()
    }
  }

  function initAll() {
    var roots = document.querySelectorAll('[data-pdp-gift]');
    for (var i = 0; i < roots.length; i++) initGift(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll); // theme-editor re-render
})();
